<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Operations Audit Drafts ">
      <a @click="$router.push({ name: 'generalMaster' })">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>

        <v-row>
          <v-col class="mt-2" sm="3">
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
              hide-details single-line style="max-width:350px;" @input="searchHandler()" />
          </v-col>
          <v-col cols="12" sm="3">
            <label class="font-weight-medium body-2">
              Centers
            </label>

            <v-autocomplete class="my-0 py-1" placeholder="--All--" v-model="franchiseeID" required
              @change="getpublishedAudits()" item-value="id" :items="centreList" key="id"
              item-text="companyName">
            </v-autocomplete>
          </v-col>
        </v-row>

        <!--Data table start -->
        <v-data-table :headers="headers" :items="auditData" disable-pagination hide-default-footer>
          <template v-slot:[`item.auditCategoryMaps`]="{ item }">
            {{ yesCount(
item.auditCategoryMaps
) }} /{{ item.auditCategoryMaps.length }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small v-on:click="
                () => {
                  $router.push({ name: 'editGeneralAudit', params: { auditId: item.id } })
                }
              ">
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <!--Data table end -->

        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange"> </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'
import _ from 'lodash'

export default {
  components: { VCardComponent, MaterialCard },
  props: [''],
  async created () {
    await this.getFranchiseList()
    await this.getpublishedAudits()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  watch: {
    franchisee: async function (val) {
      this.franchiseeID = val.id
      this.getpublishedAudits()
    }
  },
  data () {
    return {
      modules: {
        addAudit: this.checkModuleAccess('addAudit')
      },
      isWrite: true,
      search: '',
      franchiseeID: '',
      academicYearID: '',
      franchiseItems: [],
      franchiseSelect: '',
      auditData: [],
      isPublished: false,
      auditDataCopy: [],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      centreList: [],
      headers: [
        { text: 'Center', value: 'companyName', sortable: true },
        { text: 'Categories Completed', value: 'auditCategoryMaps', sortable: true },
        { text: 'Last Updated On', value: 'auditDate', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      date: new Date().toISOString().substr(0, 7),
      modal: false
      // scoreOptions: [],
      // score: '',
      // staffOptions: [],
      // staff: ''
    }
  },
  methods: {
    getpublishedAudits: async function () {
      try {
        // if (this.academicYear.id) {
        let rows = await http.get(`${constants.API_URL}/api/audit/allaudits`, {
          params: {
            page: this.page - 1,
            size: this.pageSize,
            search: this.search,
            isPublish: this.isPublished,
            franchiseeID: this.franchiseeID,
            status: 'IN-PROGRESS'
          }
        })

        this.companyName = rows.data.companyName

        this.auditData = rows.data.rows.map(item => {
          item.companyName = item.FranchiseeName[0].companyName
          item.auditDate = moment(item.createdAt).format('D MMM, YYYY')
          return item
        })
        this.auditCategoryMaps = rows.data.auditCategoryMaps

        this.totalPages = rows.data.totalPages
      } catch (e) {
        console.log(e)
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      }
    },
    getFranchiseList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee`)
        this.centreList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    yesCount: function (categories) {
      let counter = 0
      _.forEach(categories, c => {
        let tempPrms = []
        _.forEach(c.subCategories, s => {
          tempPrms = tempPrms.concat(s.parameters)
        })
        let searchIndex = tempPrms.map(a => a.status).indexOf('NO')
        if (searchIndex === -1) {
          // NO do not exist
          counter++
        }
      })

      return counter
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getpublishedAudits()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getpublishedAudits()
    },
    searchHandler: function () {
      if (this.search.length > 3) {
        this.getpublishedAudits()
      }
    }
  }
}
</script>

<style scoped>
.add-audit-offline {
  position: absolute;
  right: 150px;
  top: 18px;
}
.add-audit-online {
  position: absolute;
  right: 180px;
  top: 0;
}
</style>
